/**
 * Inferrex consent — types shared by ConsentProvider, banner, settings,
 * and the GoogleAnalytics wrapper.
 *
 * Categories follow GA4 Consent Mode v2 + UK PECR / UK GDPR conventions:
 *
 *  - necessary   : always granted. Auth, CSRF, Stripe payment-session cookies,
 *                  consent-state cookie itself. Cannot be opted out of.
 *  - analytics   : opt-in. GA4 page_view, custom events, demographics,
 *                  cross-domain attribution. Maps to gtag analytics_storage.
 *  - marketing   : opt-in. Remarketing tags, Ads attribution, conversion
 *                  signals. Maps to gtag ad_storage + ad_user_data +
 *                  ad_personalization. (Reserved — not wired yet, banner
 *                  surfaces it so the consent record is forward-compatible
 *                  when we add Ads / LinkedIn Insight Tag.)
 *
 * VERSION bumps invalidate stored consent and re-prompt. Bump when the set
 * of categories changes, or when a category's scope materially shifts so
 * that the prior consent no longer accurately describes what we'd do today.
 */

export const CONSENT_VERSION = 1;
export const CONSENT_STORAGE_KEY = 'inferrex.consent.v1';

export type ConsentCategory = 'necessary' | 'analytics' | 'marketing';

export interface ConsentState {
  version: number;
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  decidedAt: number;
}

export const DEFAULT_DENIED: Omit<ConsentState, 'decidedAt'> = {
  version: CONSENT_VERSION,
  necessary: true,
  analytics: false,
  marketing: false,
};
